import { AxiosInstance } from "axios";
import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import NotificationRulePagedRequest from "@/types/sv-data/notification-rule/NotificationRulePagedRequest";
import NotificationRulePagedResponse from "@/types/sv-data/notification-rule/NotificationRulePagedResponse";
import NotificationRule from "@/types/sv-data/notification-rule/NotificationRule";

class NotificationRuleApi {
	private axios: AxiosInstance;
	private axiosJson: any;

	private readonly apiEndpoint = "NotificationRule";

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async getNotificationRules(request: NotificationRulePagedRequest)
		: Promise<NotificationRulePagedResponse> {

		let query = `/${this.apiEndpoint}?` +
			`page=${request.page}` +
			`&pageSize=${request.pageSize}` +
			`&searchTerm=${request.searchTerm}` +
			`&sortBy=${request.sortBy}` +
			`&sortDesc=${request.sortDesc}`;

		const { data } = await this.axiosJson.get(query);

		return data;
	}

	public async createNotificationRule(notificationRule: NotificationRule) : Promise<void> {
		await this.axiosJson.post(`${this.apiEndpoint}`, notificationRule);
	}

	public async updateNotificationRule(notificationRule: NotificationRule) : Promise<void> {
		await this.axiosJson.put(`${this.apiEndpoint}`, notificationRule);
	}

	public async deleteNotificationRule(notificationRuleId: number): Promise<void>{
		await this.axios.delete(`/${this.apiEndpoint}/${notificationRuleId}`);
	}

	public async getRuleByEvent(eventId: number, eventOutcomeId?: number): Promise<NotificationRule[]> {
		const { data } = await this.axiosJson.get(`${this.apiEndpoint}/ByEvent`, {
			params: {
				eventId,
				eventOutcomeId
			}
		});
		return data;
	}
}

const notificationRuleApi = new NotificationRuleApi();
export default notificationRuleApi;
